import React from 'react';
import AdmInventorySearch from '../../components/AdminTabs/AdmInventoryCategory/AdmInventorySearch';

const InventorySearch = () => {
  return (
    <div>
      <AdmInventorySearch />
    </div>
  );
};

export default InventorySearch;
